module.exports = __webpack_public_path__ + "img/midi.6fdfcc26.png";